import React, { useEffect } from 'react';
import LeftWire from '../assets/icons/left-wire.svg?react';
import RightWire from '../assets/icons/right-wire.svg?react';
import Logo from '../assets/img/logo.svg?react';
import { appVersion } from '../application/constants/env-variables.ts';
import styles from './GlobalErrorScreen.module.scss';
import clsx from 'clsx';

const BASE_WIDTH = 1440;
const BASE_FONT_SIZE = 14;

export const GlobalErrorScreen = () => {
  useEffect(() => {
    const originalFontSize = document.documentElement.style.fontSize;

    const updateRootFontSize = () => {
      const scale = Math.min(
        Math.max(window.innerWidth / BASE_WIDTH, 0.75),
        1.2,
      );

      document.documentElement.style.fontSize = `${BASE_FONT_SIZE * scale}px`;
    };

    updateRootFontSize();
    window.addEventListener('resize', updateRootFontSize);

    return () => {
      document.documentElement.style.fontSize = originalFontSize;
      window.removeEventListener('resize', updateRootFontSize);
    };
  }, []);

  return (
    <div className={styles.wrapper}>
      <Logo className={styles.logo} />
      <div className={styles.container}>
        <div className={styles.header}>We’ll be back soon!</div>
        <div className={styles.text}>
          We’re performing some maintenance at the moment
          <br />
          to enhance your experience. Thanks for your
          <br />
          patience
        </div>
      </div>
      <LeftWire className={styles.leftWire} />
      <RightWire className={styles.rightWire} />
      <div className={styles.footerContainer}>
        <div className={clsx(styles.text, styles.rightsReserved)}>
          © 2025 Löwenstein Medical Technology GmbH + Co. KG. All rights
          reserved
        </div>
        <div className={clsx(styles.text, styles.version)}>
          Version: {appVersion()}
        </div>
      </div>
    </div>
  );
};
